<template>
  <div class="layout zeta" v-if="data">
    <div
      class="layout__item u-16/24-default u-1/2-palm"
			v-if="data && data.Text"
      :class="[sharedClass + ' ' + keyClass, {'zeta': !isTotal,'u-font-weight--bold delta': isTotal,'u-font-weight--bold ': isSemiTotal}]"
    >{{data.Text}}</div>
    <div
      v-if="data && data.Value"
      class="layout__item u-8/24-default u-1/2-palm u-text-align--right pb--"
      :class="[sharedClass + ' ' + valueClass, 
				
				{
					'zeta': !isTotal,
					'u-font-weight--bold u-border--top ': isTotal || isSemiTotal,
				'delta': isTotal}]"
    >{{data.Unit}}&nbsp;{{data.Value.replace(/\./g, ",")}}</div>
		
    <div class="layout__item u-1/2 u-text-color-grey" v-if="extraText" v-html="extraText"></div>
  </div>
</template>

<script>
export default {
	props: {
		data: Object,
		sharedClass: {
			type: String,
			default: ''
		},
		keyClass: {
			type: String,
			default: ''
		},
		extraText: {
			type: String,
			default: null
		},
		valueClass: {
			type: String,
			default: ''
		},
		isTotal: {
			type: Boolean,
			default: false
		},
		isSemiTotal: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style>
</style>
